/** Minimal GeoJSON geometry type, avoids depending on the `geojson` package. */
export interface GeoJSONGeometry {
  bbox?: number[];
  coordinates: unknown;
  type: string;
}

/**
 * The kind of a search result. The order of the keys reflects the display
 * priority of the results in the unified result list.
 */
export const SearchResultType = {
  ADDRESS: "address",
  PLACE: "place",
  POI: "poi",
  STOP: "stop",
};
export type SearchResultType =
  (typeof SearchResultType)[keyof typeof SearchResultType];

/** Display priority of the result types, lower comes first. */
export const SEARCH_RESULT_TYPE_PRIORITY: Record<SearchResultType, number> = {
  [SearchResultType.ADDRESS]: 2,
  [SearchResultType.PLACE]: 1,
  [SearchResultType.POI]: 3,
  [SearchResultType.STOP]: 0,
};

/**
 * A search result normalized across all search engines.
 * All coordinates are in WGS84 (EPSG:4326).
 */
export interface SearchResult<TFeature = unknown> {
  /** Bounding box in WGS84, only set for results representing an area. */
  bbox?: [number, number, number, number];
  /** The raw feature returned by the api, used by the stop search consumers. */
  feature: TFeature;
  geometry: GeoJSONGeometry;
  id: string;
  label: string;
  /** Index of the result within the response of its engine. */
  rank: number;
  subtitle?: string;
  type: SearchResultType;
}

export interface SearchEngineSearchOptions {
  lang?: string;
  signal: AbortSignal;
}
